// //this func is from stackoverflow
// //https://stackoverflow.com/questions/6525538/convert-utc-date-time-to-local-date-time
// export const UtcTimeToLocalConverter = (date) => {
//   var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

//   var offset = date.getTimezoneOffset() / 60;
//   var hours = date.getHours();

//   newDate.setHours(hours - offset);

//   return newDate;
// };

export const getOneMonthAgo = () => {
  let d = new Date();
  const currentDate = d.getDate();
  // Set to first day of month to avoid rollover issues
  d.setDate(1);
  // Subtract one month
  d.setMonth(d.getMonth() - 1);
  // Try to restore the original date (will automatically handle shorter months)
  d.setDate(
    Math.min(
      currentDate,
      new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()
    )
  );
  return d.toLocaleDateString();
};

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export const toLocalTime = (dateString, isShowMonthString = false) => {
  //use the commented line if we switch the backend back off of UTC
  //return dateString
  var date = new Date(dateString + " UTC");
  if (dateString === "") {
    date = new Date();
  }
  const month = isShowMonthString
    ? monthNames[date.getMonth()]
    : (date.getMonth() + 1).toString();
  return (
    month +
    "/" +
    date.getDate().toString() +
    "/" +
    date.getFullYear().toString() +
    " " +
    (date.getHours() % 12 === 0 ? 12 : date.getHours() % 12).toString() +
    ":" +
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    (date.getHours() < 12 ? " AM" : " PM")
  );
};
